import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { rating2scaleLabel } from '~/assets/helper/functions';
import { EnumIroLevelOfImpact, EnumIroType, useGetIroQuery, useUpdateIroMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetIroQuery = useGetIroQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetIroQuery.result,
      onResult = _useGetIroQuery.onResult;
    var getShowLikelihood = function getShowLikelihood(item) {
      if (item.type === EnumIroType.PositiveImpact || item.type === EnumIroType.NegativeImpact) {
        return item.levelOfImpact !== EnumIroLevelOfImpact.Actual;
      }
      return item.type === EnumIroType.Opportunity || item.type === EnumIroType.Risk;
    };
    var stakeholderTableHeaders = computed(function () {
      var baseHeaders = [
      // 'id',
      'actions', 'stakeholder.name', 'stakeholder.type', 'stakeholder.description'
      // 'impactMaterial',
      // 'financialMaterial',
      ];
      if (item.value.type === EnumIroType.Risk || item.value.type === EnumIroType.Opportunity) {
        return [].concat(baseHeaders, ['relationToRo']);
      }
      return [].concat(baseHeaders, ['howAffected']);
    });
    var initStatusOnce = _.once(function (data) {
      var _data$getIro, _data$getIro2;
      magnitudeEditing.value = !((_data$getIro = data.getIro) !== null && _data$getIro !== void 0 && _data$getIro.magnitudeReason);
      likelihoodEditing.value = !((_data$getIro2 = data.getIro) !== null && _data$getIro2 !== void 0 && _data$getIro2.likelihoodReason);
    });
    onResult(function (_ref) {
      var data = _ref.data;
      if (data !== null && data !== void 0 && data.getIro) {
        initStatusOnce(data);
      }
    });
    var item = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getIro) || {};
    });
    var _useUpdateIroMutation = useUpdateIroMutation(),
      updateIRO = _useUpdateIroMutation.mutate,
      onDone = _useUpdateIroMutation.onDone;
    onDone(function (_) {
      window.$nuxt.$emit('userMsg');
    });
    var likelihoodEditing = ref(false);
    var magnitudeEditing = ref(false);
    return {
      __sfc: true,
      route: route,
      result: result,
      onResult: onResult,
      getShowLikelihood: getShowLikelihood,
      stakeholderTableHeaders: stakeholderTableHeaders,
      initStatusOnce: initStatusOnce,
      item: item,
      updateIRO: updateIRO,
      onDone: onDone,
      likelihoodEditing: likelihoodEditing,
      magnitudeEditing: magnitudeEditing,
      rating2scaleLabel: rating2scaleLabel,
      EnumIroType: EnumIroType
    };
  }
});